// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table, th, td {
  border: 1px solid #dee2e6;
  border-collapse: collapse;
  padding: 4px;
}

.table-responsive {
  margin-top: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/app/offer/managemasters/managemasters.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["table, th, td {\r\n  border: 1px solid #dee2e6;\r\n  border-collapse: collapse;\r\n  padding: 4px;\r\n}\r\n\r\n.table-responsive {\r\n  margin-top: 15px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
